import { observable } from "mobx"
import { FbUtils, studentCollection } from "../../common/FirebaseConfig"
import { log } from "../../common/Logging"
import { Gender } from "../../shared/models/Gender"
import { Student } from "../../shared/models/Student"
import { StudentType } from "../../shared/models/StudentType"

export class StudentStoreSA {

    private static innerInstance: StudentStoreSA

    @observable
    student: Student

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    isAdmin = () => {
        if (this.student) {
            return this.student.type === StudentType.ADMIN
        }
        log.warn("Tried to get admin but student was not set. Defaulting to non-admin.")
        return false
    }

    isGirl = () => {
        if (this.student) {
            return this.student.gender === Gender.GIRL
        }
        log.warn("Tried to get gender but student was not set! Defaulting to girl.")
        return true
    }

    useShortcuts = () => {
        // Defaults to false
        if (this.student) {
            return this.student.useShortcuts
        }
        return false
    }

    currentGender = (): "girl" | "boy" => {
        return this.isGirl() ? "girl" : "boy"
    }

    listenForStudentChanges = (studentId: string) =>
        studentCollection()
            .doc(studentId)
            .onSnapshot((student) => {
                this.student = FbUtils.queryDocToDoc(student) as Student
            }, (err) => {
                log.debug(err)
            })

    findUsername = () => {
        if (this.student) {
            return this.student.screenname
        }
        return undefined
    }
}
